import setCookie from '../helpers/setCookie';
import toSlug from '../helpers/toSlug';

const $popups = $('.js-action-popup');
const $cookieBar = $('.js-cookie-bar');

const TRANSITION_TIMEOUT = 300;

const actionPopup = {
  initialize() {
    if (!$popups.length) {
      return;
    }

    if ($cookieBar.length) {
      $popups.css('bottom', $cookieBar.outerHeight() + 15);
    }

    this.handlePopupOpening();

    this.createListeners();
  },

  createListeners() {
    $popups.on('click', '.js-action-popup-close', (e) => {
      this.closePopup(this.popupForElement($(e.currentTarget)));
    });

    $popups.on('click', '[type="submit"]', (e) => {
      this.closePopup(this.popupForElement($(e.currentTarget)));
    });
  },

  popupForElement($element) {
    return $element.parents('.js-action-popup');
  },

  handlePopupOpening() {
    if (!$popups.length) {
      return;
    }

    $popups.each((i, popup) => {
      const $popup = $(popup);
      const delay = parseInt($popup.data('delay'), 10);

      if (Number.isNaN(delay)) {
        $popup.removeClass('is-hidden');
        return;
      }

      setTimeout(
        () => {
          $popup.removeClass('is-hidden');
        },
        delay * 1000,
      );
    });
  },

  closePopup($popup) {
    $popup.addClass('is-hidden');

    const cookieName: string = toSlug($popup.data('cookie-name'));
    const cookieValue: string = toSlug($popup.data('cookie-value'));
    const cookieExpires: number = parseInt($popup.data('cookie-expires-hours'), 10);

    setCookie(cookieName, cookieValue, cookieExpires);

    setTimeout(
      () => {
        $popup.remove();
      },
      TRANSITION_TIMEOUT,
    );
  },
};

export default actionPopup;
